export default function ButtonArea({ children, style }) {
	return <div className="button-area" style={style}>
		{children}
	</div>;
}